"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var keycodes = {
    END: 'End',
    ENTER: 'Enter',
    HOME: 'Home',
    SPACE: ' ',
    SPACE_DEPRECATED: 'Spacebar',
    UP: 'ArrowUp',
    DOWN: 'ArrowDown',
    LEFT: 'ArrowLeft',
    RIGHT: 'ArrowRight',
};
exports.default = keycodes;
//# sourceMappingURL=keycodes.js.map